import toKebabCase from '@anwb/poncho/utilities/to-kebab-case';
import { GaFunnelInfo } from 'types/gaFunnelInfo';
import { trackEvent } from 'utils/trackEvent';

import { LeaseCarDataService, Option } from '../../../../../../types';

export const customOptionChangeGA4TrackEvent = (
	option: Option | LeaseCarDataService | undefined,
	added: boolean,
	gaFunnelInfo: GaFunnelInfo
): void => {
	if (option) {
		trackEvent({
			event: 'user_interaction',
			type: 'form',
			component: 'form-input-checkbox',
			field: '',
			action: 'click',
			actionValue: added ? 'on' : 'off',
			category: 'options-and-accessoires',
			variant: toKebabCase(option?.description),
			...gaFunnelInfo,
		});
	}
};

export const customTooltipTaggingEvent = (
	description: string,
	open: boolean | undefined,
	gaFunnelInfo: GaFunnelInfo
): void => {
	if (open) {
		trackEvent({
			event: 'user_interaction',
			type: 'form',
			component: 'tooltip',
			field: toKebabCase(description),
			action: 'click',
			actionValue: 'open',
			...gaFunnelInfo,
		});
	}
};
